import * as styles from "./DialogTitle.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";

import type { DialogTitleProps } from "./Dialog.types";

export function DialogTitle({
  className,
  ...props
}: DialogTitleProps): JSX.Element {
  return (
    <BaseDialog.Title
      data-slot="dialog-title"
      className={clsx(styles.title, className)}
      {...props}
    />
  );
}
